<template>
    <div class="options">
        <p class="text-answer">Datum en tijd</p>
    </div>
</template>

<script setup lang="ts">

</script>
